import React, { Fragment } from 'react';
import { XIcon, KeyboardIcon, CommandIcon } from 'lucide-react';
import { useOrganization } from '../contexts/OrganizationContext';
interface KeyboardShortcutsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function KeyboardShortcutsModal({
  isOpen,
  onClose
}: KeyboardShortcutsModalProps) {
  const {
    t
  } = useOrganization();
  if (!isOpen) return null;
  const shortcuts = [{
    category: t.navigation,
    items: [{
      keys: ['D'],
      description: t.goToDashboard
    }, {
      keys: ['R'],
      description: t.goToResults
    }, {
      keys: ['I'],
      description: t.goToIntegrations
    }, {
      keys: ['T'],
      description: t.goToTaxonomy
    }, {
      keys: ['P'],
      description: t.goToPreview
    }]
  }, {
    category: t.general,
    items: [{
      keys: ['Shift', '?'],
      description: t.showKeyboardShortcuts
    }, {
      keys: ['Esc'],
      description: t.closeDialog
    }]
  }];
  return <>
      <div className="modal-backdrop" onClick={onClose} style={{
      animation: 'fadeIn 200ms cubic-bezier(0.4, 0, 0.2, 1)'
    }} data-id="element-236" />
      <div className="modal-container" data-id="element-237">
        <div className="modal-content bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-hidden" style={{
        animation: 'scaleIn 200ms cubic-bezier(0.34, 1.56, 0.64, 1)'
      }} data-id="element-238">
          {/* Header */}
          <div className="bg-gradient-to-r from-purple-600 to-purple-700 px-6 py-5 flex items-center justify-between" data-id="element-239">
            <div className="flex items-center gap-3" data-id="element-240">
              <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center transition-transform duration-200 hover:scale-110" data-id="element-241">
                <KeyboardIcon className="w-5 h-5 text-white" data-id="element-242" />
              </div>
              <h2 className="text-2xl font-bold text-white" data-id="element-243">
                {t.keyboardShortcutsTitle}
              </h2>
            </div>
            <button onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-white/10 transition-all duration-200 text-white hover:scale-110 active:scale-95" aria-label="Close" data-id="element-244">
              <XIcon className="w-5 h-5" data-id="element-245" />
            </button>
          </div>
          {/* Content */}
          <div className="p-6 overflow-y-auto max-h-[calc(90vh-80px)] custom-scrollbar" data-id="element-246">
            <div className="space-y-8" data-id="element-247">
              {shortcuts.map((section, sectionIndex) => <div key={sectionIndex} className="animate-slide-in-up" style={{
              animationDelay: `${sectionIndex * 100}ms`
            }} data-id="element-248">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2" data-id="element-249">
                    <CommandIcon className="w-5 h-5 text-purple-600" data-id="element-250" />
                    {section.category}
                  </h3>
                  <div className="space-y-2" data-id="element-251">
                    {section.items.map((shortcut, itemIndex) => <div key={itemIndex} className="flex items-center justify-between p-4 bg-gradient-to-r from-gray-50 to-purple-50 rounded-xl border-2 border-gray-200 hover:border-purple-300 transition-all duration-200 hover:shadow-sm hover:scale-102 active:scale-98" style={{
                  animation: 'scaleIn 200ms cubic-bezier(0.34, 1.56, 0.64, 1)',
                  animationDelay: `${sectionIndex * 100 + itemIndex * 50}ms`
                }} data-id="element-252">
                        <span className="text-gray-700 font-medium" data-id="element-253">
                          {shortcut.description}
                        </span>
                        <div className="flex items-center gap-2" data-id="element-254">
                          {shortcut.keys.map((key, keyIndex) => <Fragment key={keyIndex} data-id="element-255">
                              {keyIndex > 0 && <span className="text-gray-400 text-sm" data-id="element-256">+</span>}
                              <kbd className="px-3 py-2 bg-white border-2 border-gray-300 rounded-lg text-sm font-semibold text-gray-700 shadow-sm min-w-[2.5rem] text-center transition-all duration-200 hover:scale-110 hover:shadow-md hover:border-purple-400" data-id="element-257">
                                {key}
                              </kbd>
                            </Fragment>)}
                        </div>
                      </div>)}
                  </div>
                </div>)}
            </div>
            {/* Hint */}
            <div className="mt-8 pt-6 border-t border-gray-200 animate-fade-in" style={{
            animationDelay: '300ms'
          }} data-id="element-258">
              <div className="bg-gradient-to-br from-purple-50 to-blue-50 rounded-xl p-4 border-2 border-purple-200 transition-all duration-200 hover:shadow-sm hover:border-purple-300" data-id="element-259">
                <p className="text-sm text-gray-700 text-center font-medium" data-id="element-260">
                  💡 {t.keyboardShortcutsHint}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>;
}